module.exports = __webpack_public_path__ + "static/img/05002B_1_C_20210423_LC.afa8c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05002B_1_C_20210423_LC.png
// module id = +zn+
// module chunks = 0